<div *ngIf="showWarning" class="warning-container">
    Your uncertified logs are
    <span *ngIf="!maxWarning; else max">currently {{warningNumber}} </span>
    <ng-template #max>
        <span>at least 14 </span>
    </ng-template>
    days old. Logs over 14 days old must be certified before your next drive shift.
</div>
